import { Component, Input, Output, EventEmitter, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faNoteSticky,
  faEnvelope,
  faPhone,
  faCalendarDays,
  faXmark,
  faCircleInfo,
  faClock,
} from '@fortawesome/pro-solid-svg-icons';
import { PipelinesService, DealActivity } from '../../../../core/services/pipelines.service';
import { Auth } from '../../../../core/auth/auth';

@Component({
  selector: 'app-deal-activity-modal',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './deal-activity-modal.html',
  styleUrls: ['./deal-activity-modal.scss'],
})
export class DealActivityModal implements OnInit {
  @Input() dealId!: string;
  @Input() dealName!: string;
  @Output() close = new EventEmitter<void>();

  private readonly pipelinesService = inject(PipelinesService);
  private readonly authService = inject(Auth);

  activities: DealActivity[] = [];
  isLoading = true;
  error: string | null = null;

  faXmark = faXmark;
  faCircleInfo = faCircleInfo;
  faClock = faClock;

  get isAdmin(): boolean {
    return this.authService.currentUser?.roles.includes('admin') || false;
  }

  ngOnInit(): void {
    this.loadActivities();
  }

  loadActivities(): void {
    this.isLoading = true;
    this.pipelinesService.getDealActivity(this.dealId).subscribe({
      next: (response) => {
        this.activities = response.data.sort(
          (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
        );
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'No se pudo cargar la actividad de la oportunidad.';
        this.isLoading = false;
        console.error('Error loading deal activity:', err);
      },
    });
  }

  getActivityIcon(type: string) {
    switch (type) {
      case 'notes':
        return faNoteSticky;
      case 'emails':
        return faEnvelope;
      case 'calls':
        return faPhone;
      case 'meetings':
        return faCalendarDays;
      default:
        return faCircleInfo;
    }
  }

  getActivityTypeLabel(type: string): string {
    switch (type) {
      case 'notes':
        return 'Nota';
      case 'emails':
        return 'Correo electrónico';
      case 'calls':
        return 'Llamada';
      case 'meetings':
        return 'Reunión';
      default:
        return type;
    }
  }

  getActivityColorClass(type: string): string {
    switch (type) {
      case 'notes':
        return 'bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400';
      case 'emails':
        return 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400';
      case 'calls':
        return 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400';
      case 'meetings':
        return 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400';
      default:
        return 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400';
    }
  }

  onClose(): void {
    this.close.emit();
  }
}
